/* Dentellis — bouton fixe mobile de la fiche produit (voir snippets/dnt-cta-mobile.liquid). */
(function () {
  var barre = document.querySelector('[data-dnt-cta]');
  if (!barre) return;
  var bouton = barre.querySelector('[data-dnt-cta-btn]');
  var formulaire = document.querySelector('.t4s-main-product__content .t4s-product-form__variants');
  if (!formulaire) return;
  var atc = formulaire.querySelector('button[type="submit"]');
  if (!atc) return;
  var mobile = window.matchMedia('(max-width: 767px)');
  var atcVisible = true;

  function tailleManquante() {
    var options = formulaire.querySelectorAll('[data-swatch-option]');
    for (var i = 0; i < options.length; i++) {
      if (!options[i].querySelector('input:checked, [data-swatch-item].is--selected')) return options[i];
    }
    return null;
  }
  function prix() {
    var p = document.querySelector('.t4s-product__info-container .t4s-product-price');
    if (!p) return '';
    var ins = p.querySelector('ins');
    return (ins || p).textContent.trim();
  }
  // Message sous le bouton principal tant qu'une taille manque (le bouton Kalles est alors grisé, sans explication)
  var aide = document.createElement('p');
  aide.className = 'dnt-aide-taille';
  aide.textContent = bouton.getAttribute('data-aide');
  var zone = atc.closest('.t4s-product-form__buttons') || atc.parentNode;
  zone.parentNode.insertBefore(aide, zone.nextSibling);
  function maj() {
    var manque = tailleManquante();
    aide.hidden = !manque;
    if (manque) {
      bouton.textContent = bouton.getAttribute('data-choisir');
      bouton.classList.remove('is--ajout');
    } else if (atc.disabled && atc.getAttribute('aria-disabled') !== 'false') {
      bouton.textContent = bouton.getAttribute('data-epuise');
      bouton.classList.remove('is--ajout');
    } else {
      var p = prix();
      bouton.textContent = bouton.getAttribute('data-ajouter') + (p ? ' · ' + p : '');
      bouton.classList.add('is--ajout');
    }
    barre.hidden = !mobile.matches || atcVisible;
    placer();
  }
  // Au-dessus de la barre d'outils mobile Kalles (Boutique, Panier, Compte…) quand elle est affichée
  var outils = document.querySelector('.t4s-toolbar');
  function placer() {
    if (barre.hidden || !outils) return;
    var r = outils.getBoundingClientRect();
    var visible = getComputedStyle(outils).display !== 'none' && r.height > 0 && r.top < window.innerHeight;
    barre.style.bottom = visible ? Math.max(0, window.innerHeight - r.top) + 'px' : '0px';
  }
  var attente = false;
  window.addEventListener('scroll', function () { if (attente) return; attente = true; requestAnimationFrame(function () { attente = false; placer(); }); }, { passive: true });
  bouton.addEventListener('click', function () {
    var manque = tailleManquante();
    if (manque) {
      var y = manque.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
      manque.classList.add('dnt-cta-surligne');
      setTimeout(function () { manque.classList.remove('dnt-cta-surligne'); }, 1600);
    } else if (!atc.disabled) {
      atc.click();
    }
  });
  var accTailles = document.querySelector('#dnt-acc-tailles[data-ensemble]');
  if (accTailles) {
    document.addEventListener('click', function (e) {
      var lien = e.target.closest && e.target.closest('.t4s-main-product__content .t4s-btn__size-chart');
      if (!lien) return;
      e.preventDefault(); e.stopImmediatePropagation();
      accTailles.open = true;
      window.scrollTo({ top: accTailles.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
    }, true);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { atcVisible = e[0].isIntersecting; maj(); }).observe(atc);
  }
  formulaire.addEventListener('change', function () { setTimeout(maj, 50); });
  formulaire.addEventListener('click', function () { setTimeout(maj, 80); });
  new MutationObserver(maj).observe(atc, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
  if (mobile.addEventListener) mobile.addEventListener('change', maj);
  maj();
})();
